import React from "react";
import ApiService from "../../../Services/ApiService";
import AlertService from "../../../Services/AlertService";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";


class PlacementSection extends React.Component {

    state = {
        options: [],
        selectedOptions: [],
        selectedCategories: [],
        title: ''
    };


    componentDidMount() {
        if (this.props) {
            let selectedOptions = this.props.categories.filter((el) => {
                return this.props.selectedCategories.indexOf(el.label) > -1
            });

            let selectedCategories = selectedOptions.map(option => option.label);

            this.setState({...this.state,
                title: this.props.title,
                options: this.props.categories,
                selectedOptions: selectedOptions,
                selectedCategories: selectedCategories
            })
        }
    }


    getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {
        if (value && value.some((o) => o.value === "*") || value.length === this.props.categories.length) {
            return `${placeholderButtonLabel}: All`;
        } else {
            return `${placeholderButtonLabel}: ${value.length} selected`;
        }
    }

    onChange = (value, event) => {
        let selectedCategories = this.state.selectedCategories;
        if (event.action === "select-option" && event.option.value === "*") {
            selectedCategories = this.state.options.map(option => option.label);

            this.setState({...this.state, selectedOptions: [{ label: "All", value: "*" }, ...this.state.options], selectedCategories: selectedCategories});
        } else if ( event.action === "deselect-option" && event.option.value === "*") {
            selectedCategories = [];
            this.setState({...this.state, selectedOptions: [], selectedCategories: []});
        } else if (event.action === "deselect-option") {
            console.log(event.option);
            let index = selectedCategories.indexOf(event.option.label);
            if (index > -1 ) {
                selectedCategories.splice(index, 1);
            }
            this.setState({...this.state, selectedOptions: value.filter((o) => o.value !== "*"), selectedCategories: selectedCategories});
        } else if (value.length === this.state.options.length) {
            selectedCategories = this.state.options.map(option => option.label);

            this.setState({...this.state, selectedOptions: this.state.options, selectedCategories: selectedCategories});
        } else {
            selectedCategories.push(event.option.label);
            this.setState({...this.state, selectedOptions: value, selectedCategories: selectedCategories});
        }

        this.props.onPlacementChange(this.state.title, selectedCategories);
    }


    render() {
        if (this.state.options) {
            return(<div className="page-main">
                    <div className="form-container">
                        <section>
                            <h2>{this.state.title}</h2>
                            <ReactMultiSelectCheckboxes
                                options={[{ label: "All", value: "*" }, ...this.state.options]}
                                placeholderButtonLabel={this.state.title}
                                value={this.state.selectedOptions}
                                getDropdownButtonLabel={this.getDropdownButtonLabel}
                                onChange={this.onChange}

                            />
                        </section>

                    </div>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }

}

export default PlacementSection